import { render, staticRenderFns } from "./businessClient_detail.vue?vue&type=template&id=12c8202c"
import script from "./businessClient_detail.vue?vue&type=script&lang=js"
export * from "./businessClient_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports